import { ProgrammePage } from "@/components/site/ProgrammePage";

export default function Jupeb() {
  return (
    <ProgrammePage
      code="JUPEB"
      title="JUPEB Programme"
      subtitle="A structured advanced-level pathway toward eligible Direct Entry opportunities."
      intro="JUPEB (Joint Universities Preliminary Examinations Board) is a structured advanced-level programme that prepares candidates through quality teaching and disciplined study for a nationally recognised examination. Successful candidates may use their qualification to pursue eligible Direct Entry opportunities."
      blocks={[
        { t: "What JUPEB Is", d: "An advanced-level foundation programme culminating in a recognised examination used for eligible Direct Entry opportunities." },
        { t: "Who It Is For", d: "SSCE holders, awaiting-result candidates, eligible SSS3 students and candidates seeking an alternative admission pathway." },
        { t: "How the Programme Works", d: "Candidates enrol, attend structured lessons across their chosen subject combination, and prepare thoroughly for the examination." },
        { t: "Duration", d: "The programme duration is configurable per academic session. Confirm the current duration with the admissions office." },
        { t: "Academic Structure", d: "Focused instruction across a defined subject combination aligned to the candidate's intended course area." },
        { t: "Examination", d: "Candidates prepare for and sit the JUPEB examination administered under its examination body." },
        { t: "Direct Entry Pathway", d: "Successful candidates may pursue eligible Direct Entry opportunities into 200 Level, subject to the receiving institution's requirements." },
        { t: "Admission Considerations", d: "Available pathways depend on subject combination, chosen programme, receiving institution and applicable admission requirements." },
      ]}
      seo={{
        title: "JUPEB Programme | IAUE School of Basic Studies, Port Harcourt",
        description: "JUPEB advanced-level programme at the School of Basic Studies, IAUE Port Harcourt — subject combinations, examination and eligible Direct Entry pathway into 200 Level.",
      }}
    />
  );
}
